import { AngleRight, Button, ChakraBox } from '@equip.health/ui';

export type PrimaryCTAButtonProps = {
  display: string;
  hideRightIcon?: boolean;
  isDisabled: boolean;
  onClick: () => void;
};

const PrimaryCTAButton = ({
  display,
  hideRightIcon = false,
  isDisabled,
  onClick,
}: PrimaryCTAButtonProps) => (
  <Button
    id={`patient-profile-surveys-primary-cta__${display}`}
    isDisabled={isDisabled}
    onClick={onClick}
    padding="12px 16px 12px 12px"
    rightIcon={
      hideRightIcon ? undefined : (
        <ChakraBox marginLeft="8px">
          <AngleRight fill="white" height="15px" width="8px" />
        </ChakraBox>
      )
    }
    size="sm"
  >
    {display}
  </Button>
);

export default PrimaryCTAButton;
